import React, { useState, useEffect, useContext } from "react";
import { PrintModal } from "../../../components/modal/printModal";
import { TrashIcon, ViewfinderCircleIcon } from "@heroicons/react/24/outline";
import { Table } from "../../../components/table";
import { Button } from "../../../components/button";

function Checkpoints({
  handleCheckpointsAddMode,
  fetchCheckpointsList,
  isLoading,
  checkpointsListData,
  handleDeleteCheckpoint,
  setIsCheckpointsAddMode,
  toggleOpen,
}) {
  const [isPrintModalOpen, setPrintModalOpen] = useState(false);
  const [selectedCheckpoint, setSelectedCheckpoint] = useState(null);

  useEffect(() => {
    fetchCheckpointsList();
  }, []);

  const handlePrintModalOpen = (checkpoint) => {
    setSelectedCheckpoint(checkpoint);
    setPrintModalOpen(true);
  };

  const handlePrintModalClose = () => {
    setPrintModalOpen(false);
    setSelectedCheckpoint(null);
  };

  /// Table columns ///
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "checkpoint_name",
        // Use a custom cell to render the link
        Cell: ({ row }) => (
          <div>
            <a
              onClick={() => {
                handleCheckpointsAddMode(row.original.id, row.original.type_id);
              }}
              className="text-gray-800 dark:text-gray-100 hover:text-gray-900 dark:hover:text-white hover:underline cursor-pointer"
            >
              {row.values.checkpoint_name}
            </a>
          </div>
        ),
      },
      {
        Header: "Description",
        accessor: "checkpoint_description",
      },
      {
        Header: "Type",
        accessor: "checkpoint_type",
        Cell: ({ row }) => (
          <div>
            {row.original.type_id === 2 ? (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handlePrintModalOpen(row.original);
                }}
                className="text-gray-800 dark:text-gray-100 hover:text-gray-900 dark:hover:text-white hover:underline"
              >
                {row.original.type_name}
              </a>
            ) : (
              row.original.type_name
            )}
          </div>
        ),
      },
      {
        Header: "",
        id: "delete",
        accessor: (str) => "delete",
        Cell: ({ row }) => (
          <button
            onClick={() =>
              handleDeleteCheckpoint(
                row.original.checkpoint_name,
                row.original.id
              )
            }
            className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors duration-150"
          >
            <TrashIcon className="h-4 w-4 shrink-0" />
          </button>
        ),
      },
    ],
    []
  );

  return (
    <div>
      <Table
        data={checkpointsListData || []}
        columns={columns}
        defaultSort="checkpoint_name"
        isLoading={isLoading || checkpointsListData === undefined}
        emptyState={
          <div className="flex flex-col items-center justify-center h-72">
            <ViewfinderCircleIcon className="h-10 w-10 text-gray-300 dark:text-gray-600" />
            <p className="mt-3 mb-4 text-sm text-gray-400 dark:text-gray-500 text-center">
              No checkpoints yet
            </p>
            <Button
              onClick={() => {
                setIsCheckpointsAddMode(true);
                toggleOpen();
              }}
            >
              Create checkpoint
            </Button>
          </div>
        }
      />

      {isPrintModalOpen && (
        <PrintModal
          isOpen={isPrintModalOpen}
          toggleOpen={handlePrintModalClose}
          selectedItem={selectedCheckpoint}
          title={`Print QR code for ${selectedCheckpoint?.checkpoint_name}?`}
          message={`Print this QR code and place in the desired site for your team to scan and conduct the checkpoint.`}
          handleSuccess={() => {
            // handle success logic here
          }}
          onPrint={() => {
            // handle print logic here
          }}
        />
      )}
    </div>
  );
}

export { Checkpoints };
